module.exports = __webpack_public_path__ + "static/guidance-hero-66e10b71de92e07707218b43c57829e2.jpg";